function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".6",
  d: "M16.36 18.49c-.01.01-.01.02-.01.02A20.414 20.414 0 0112 22S3.16 17.58 2.1 7.08C5.21 17.15 12 10 12 10c6.76 2.9 4.52 8.14 4.36 8.49z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.36 18.49c.16-.35 2.4-5.59-4.36-8.49-1-6 4.07-7.06 4.07-7.06l.59-.12h.01C18.41 3.23 20.2 3.92 22 5c0 0 0 7.5-5.64 13.49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.66 2.82l-.59.12S11 4 12 10c0 0-6.79 7.15-9.9-2.92v-.01C2.04 6.41 2 5.71 2 5 2 5 8.72.97 16.66 2.82z"
})));